var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('portal',{attrs:{"to":"toolbar-subtitle"}},[_vm._v(" Εικόνες Ανελκυστήρα")]),_c('v-card',[_c('v-card-text',[_c('media-library',{attrs:{"mobile-layout":_vm.isMobile,"directories":_vm.tmimata,"media":_vm.projectMedia,"media-directory-key":"TmimaDescr","media-url-key":"Url"},on:{"onDelete":_vm.deletePicture}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }